import { gql } from "@apollo/client";

export type DropdownQueryType<P = {
  value: any;
  label: any;
}> = {
	dropdown: {
		items: P[]
	}
}

export const SectorsDropdownQuery = gql`
  query {
    dropdown: Sectors(order: { Description: ASC }) {
      items {
        value: URL
        label: Description
      }
    }
  }
`;

export const SustainabilitiesDropdownQuery = gql`
  query {
    dropdown: Sustainabilities {
      items {
        value: ID
        label: Description
      }
    }
  }
`;

export const StandardsDropdownQuery = gql`
  query {
    dropdown: Standards (order: { Description: ASC }) {
      items {
        value: ID
        label: Description
      }
    }
  }
`;

export const TitlesDropdownQuery = gql`
  query {
    dropdown: Titles {
      items {
        value: ID
        label: Description
      }
    }
  }
`;

export const SealProductsDropdownQuery = gql`
  query($where: SealProductFilterInput) {
    dropdown: SealProducts(where: $where, order: { ID: ASC }) {
      items {
        value: ID
        label: Name
      }
    }
  }
`;

export const OutputTypesDropdownQuery = gql`
  query {
    dropdown: OutputTypes(order: { ID: ASC }) {
      items {
        value: ID
        label: Description
      }
    }
  }
`;

export const CountriesDropdownQuery = gql`
  query {
    dropdown: Countries(order: { Description: ASC }) {
      items {
        value: ID
        label: Description
      }
    }
  }
`;

export const CountriesWithIDDropdownQuery = gql`
  query {
    dropdown: Countries(order: { Description: ASC }) {
      items {
        value: ID
        label: Description
      }
    }
  }
`;

export const JobRolesDropdownQuery = gql`
  query {
    dropdown: JobRoles(order: { ID: ASC }) {
      items {
        value: ID
        label: Description
      }
    }
  }
`;

export const JobRolesBoxDropdownQuery = gql`
  query {
    boxes: JobRoles(order: { ID: ASC }) {
      items {
        value: ID
        label: Description
      }
    }
  }
`;

export const OrganisationsDropdownQuery = gql`
  query {
    dropdown: Organisations(order: { CompanyName: ASC }) {
      items {
        value: ID
        label: CompanyName
      }
    }
  }
`;

export const OrganisationTypesDropdownQuery = gql`
  query {
    dropdown: OrganisationTypes(order: { Description: ASC }) {
      items {
        value: ID
        label: Description
      }
    }
  }
`;

export const MobileCountriesDropdownQuery = gql`
query {
    dropdown: Countries(order: { PhonePrefix: ASC }) {
        items {
            value: ID
            label: PhonePrefix
        }
    }
}
`;

export const CertifyingBodiesDropdownQuery = gql`
  query {
    dropdown: CertifyingBodies(order: { Description: ASC }) {
      items {
        value: ID
        label: Description
      }
    }
  }
`;

export const CertifyingBodiesBoxQuery = gql`
  query {
    boxes: CertifyingBodies(order: { Description: ASC }) {
      items {
        value: ID
        label: Description
      }
    }
  }
`;

export const BuildingsDropdownQuery = gql`
  query ($where: BuildingFilterInput){
    dropdown: Buildings(where: $where, order: { BuildingName: ASC }) {
      items {
        value: ID
        label: BuildingName
      }
    }
  }
`;

export const DoorSystemsDropdownQuery = gql`
  query {
    dropdown: DoorSystems(order: { Name: ASC }) {
      items {
        value: ID
        label: Name
        DoorSystemParameters {
          ID
          DefaultValue
          DisplayName
          DoorSystemID
          DoorSystemParameterGroupID
          HiddenOnDoorConfigIDs
          ListOrder
          MaxValue
          MinValue
          ParameterName
          ParameterType
          Units
        }
        DoorConfigSizes {
          DoorConfigID
          DoorConfig {
            Value {
              Code
              Description
            }
          }
          FromWidth
          ToWidth
          FromHeight
          ToHeight
          OutputTypes {
              ID
              Description
          }
          DoorConfig {
            Value {
              Code
              Description
            }
          }
        }
      }
    }
  }
`;

export const DoorSystemsValueNameDropdownQuery = gql`
  query {
    dropdown: DoorSystems(order: { Name: ASC }) {
      items {
        value: Name
        label: Name
      }
    }
  }
`;

export const ProductLinesDropdownQuery = gql`
  query {
    dropdown: ProductLines(order: { Description: ASC }) {
      items {
        value: ID
        label: Name
      }
    }
  }
`;

export const ProjectsDropdownQuery = gql`
query($where: ProjectFilterInput) {
    dropdown: Projects(
      where: $where,
      order: { Name: ASC }
    ) {
        items {
            value: ID
            label: Name
            MultipleBuildings
        }
    }
}
`;

export const FireRatingsMinsDropdownQuery = gql`
  query {
    dropdown: FireRatings {
      items {
        value: ID
        label: RatingMins
      }
    }
  }
`;

export const FireRatingsDropdownQuery = gql`
  query(
    $where: FireRatingFilterInput
  ) {
    dropdown: FireRatings(
      where: $where
    ) {
      items {
        value: ID
        label: Description
      }
    }
  }
`;

export const FinishTypesDropdownQuery = gql`
  query(
    $where:FinishTypeFilterInput
  ) {
    dropdown: FinishTypes(
      where: $where
    ) {
      items {
        value: ID
        label: Description
      }
    }
  }
`;

export const FrameMaterialsDropdownQuery = gql`
  query {
    dropdown: FrameMaterials {
      items {
        value: ID
        label: Description
      }
    }
  }
`;

export const MaterialTypesDropdownQuery = gql`
  query {
    dropdown: MaterialTypes {
      items {
        value: ID
        label: Description
      }
    }
  }
`;

export const DoorTypesDropdownQuery = gql`
  query {
    dropdown: DoorTypes {
      items {
        value: ID
        label: Description
      }
    }
  }
`;

export const SealTypesDropdownQuery = gql`
  query {
    dropdown: SealTypes {
      items {
        value: ID
        label: Description
      }
    }
  }
`;

export const SealLocationsDropdownQuery = gql`
  query {
    dropdown: SealLocations {
      items {
        value: ID
        label: Description
      }
    }
  }
`;
export const ProductTypesDropdownQuery = gql`
  query {
    dropdown: ProductTypes {
      items {
        value: ID
        label: Description
      }
    }
  }
`;

export const PaymentMethodsDropdownQuery = gql`
query($where: PaymentMethodFilterInput) {
    dropdown: PaymentMethods(where: $where) {
      items {
        value: ID
        label: Description
      }
    }
  }
`;

export const ProjectBuildingsDropdownQuery = gql`
query($where: ProjectBuildingFilterInput) {
    dropdown: ProjectBuildings(where: $where) {
      items {
        value: ID
        label: BuildingName
      }
    }
  }
`;

export const LippingTypesDropdownQuery = gql`
query($where: LippingTypeFilterInput) {
  dropdown: LippingTypes(where: $where) {
    items {
      value: ID
      label: Description
    }
  }
}
`;

export const DoorConfigsDropdownQuery = gql`
  query {
    dropdown: DoorConfigs {
      items {
        value: ID
        label: Description
        Code
        DoubleDoor
        IconImage
        Latched
        Overpanel
      }
    }
  }
`;

export const OrganisationCurrenciesDropdownQuery = gql`
  query($organisationID: Int!) {
    dropdown: OrganisationCurrencies(OrganisationID: $organisationID) {
      items {
        Currency {
          Value {
            ID
            Code
          }
        }
      }
    }
  }
`;

export const OrganisationAvailableCurrenciesDropdownQuery = gql`
  query($organisationID: Int!) {
    dropdown: OrganisationCurrencies(OrganisationID: $organisationID) {
      items {
        ID
        Currency {
          Value {
            Code
            ID
          }
        }
      }
    }
  }
`;


export const CurrenciesDropdownQuery = gql`
query($where: CurrencyFilterInput) {
    dropdown: Currencies(where: $where) {
      items {
        value: ID
        label: Code
      }
    }
  }
`;

export const CustomDoorSystemsDropdownQuery = gql`
query($where: CustomDoorSystemFilterInput) {
    dropdown: CustomDoorSystems(where: $where, order: { Name: ASC }) {
      items {
        value: ID
        label: Name
      }
    }
  }
`;

export const CustomDoorSystemsWithFieldsDropdownQuery = gql`
  query($where: CustomDoorSystemFilterInput) {
    dropdown: CustomDoorSystems(where: $where, order: { Name: ASC }) {
      items {
        value: ID
        label: Name,
        LippingTypeID
        FrameFinish
        FrameSection
        LeafFacing
        FrameType
        VisionPanelBeading
      }
    }
  }
`;

export const BuildingUseDropdownQuery = gql`
  query {
    dropdown: BuildingUse {
      value: ID
      label: Description
    }
  }
`;

export const UserPositionDropdownQuery = gql`
  query {
    dropdown: UserPosition {
      value: ID
      label: Description
    }
  }
`;